import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import ViewWorkHeader from '@Components/ViewWork/Headers/ViewWorkHeader'

interface WorkDraftHeaderProps {
    work: WorkModel
    editOnClick: () => void
}

const WorkDraftHeader = (props: WorkDraftHeaderProps) => {
    const { rightsholderStore } = useContext(StoresContext)

    return (
        <ViewWorkHeader work={props.work}>
            <>
                <div className="sub-data">
                    <div>
                        Last Edited:
                        <span className="bold">
                            {props.work.updateDate &&
                                new Date(props.work.updateDate).toLocaleString('default', {
                                    month: 'long',
                                    day: 'numeric',
                                    year: 'numeric',
                                })}
                        </span>
                    </div>
                </div>
                <Button
                    linkOnClick={props.editOnClick}
                    mainColor
                    type="primary-small"
                    linkTo={Navigation.rightholder.registrationDrafts.editRoot(
                        rightsholderStore.currentRightsholderId,
                        'draft',
                        props.work.id as number
                    )}
                    typeLink
                >
                    Edit
                </Button>
            </>
        </ViewWorkHeader>
    )
}

export default WorkDraftHeader
